<template>
  <canvas ref="canvas" :width="width" :height="height" />
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';

const props = defineProps({
  data: { type: Array, default: () => [] },
  width: { type: Number, default: 100 },
  height: { type: Number, default: 28 },
});

const canvas = ref(null);
const padding = 2;

function draw() {
  const el = canvas.value;
  if (!el || !props.data || props.data.length < 2) {
    if (el) el.getContext('2d').clearRect(0, 0, props.width, props.height);
    return;
  }

  const ctx = el.getContext('2d');
  const w = props.width;
  const h = props.height;
  const points = props.data;

  ctx.clearRect(0, 0, w, h);

  const min = Math.min(...points);
  const max = Math.max(...points);
  const range = max - min || 1;

  const drawW = w - padding * 2;
  const drawH = h - padding * 2;

  const xStep = drawW / (points.length - 1);
  const coords = points.map((v, i) => ({
    x: padding + i * xStep,
    y: padding + drawH - ((v - min) / range) * drawH,
  }));

  const color = points[points.length - 1] >= points[0] ? '#22c55e' : '#ef4444';

  // Fill gradient
  const grad = ctx.createLinearGradient(0, 0, 0, h);
  grad.addColorStop(0, color + '26'); // ~0.15 opacity
  grad.addColorStop(1, color + '00'); // 0 opacity

  ctx.beginPath();
  ctx.moveTo(coords[0].x, coords[0].y);
  for (let i = 1; i < coords.length; i++) {
    ctx.lineTo(coords[i].x, coords[i].y);
  }
  ctx.lineTo(coords[coords.length - 1].x, h);
  ctx.lineTo(coords[0].x, h);
  ctx.closePath();
  ctx.fillStyle = grad;
  ctx.fill();

  // Polyline
  ctx.beginPath();
  ctx.moveTo(coords[0].x, coords[0].y);
  for (let i = 1; i < coords.length; i++) {
    ctx.lineTo(coords[i].x, coords[i].y);
  }
  ctx.strokeStyle = color;
  ctx.lineWidth = 1.5;
  ctx.lineJoin = 'round';
  ctx.stroke();
}

onMounted(draw);
watch(() => props.data, draw, { deep: true });
watch(() => [props.width, props.height], draw);
</script>
